import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b0dba86e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "picture-tab" }
const _hoisted_2 = { class: "picture-management" }
const _hoisted_3 = {
  key: 1,
  class: "awaiting-image"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-duotone fa-thin fa-screwdriver-wrench" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]

import { onMounted, ref, watch, inject, PropType } from "vue";
import DxGallery from "devextreme-vue/gallery";
import CarouselPicture from "@/components/carousel-pictures/carousel-picture.vue";
import { CarouselPictureType } from "@/enums/CarouselRecordType";
import displayErrorMessage from "@/utils/ErrorHandling";
import { getErrorMessage } from "bright-logic-core/src/errors";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import { MaintenanceRequests } from "acquaint-api/models/MaintenanceRequests";


export default /*#__PURE__*/_defineComponent({
  __name: 'maintenance-request-picture-tab',
  props: {
  /**
   * The MaintenanceRequests object value
   * @type {MaintenanceRequests}
   * @required: true
   */
  maintenanceRequests: {
    type: Object as PropType<MaintenanceRequests>,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const apiClient = inject("AcquaintApiClient") as AcquaintApiClient;
const pictureList = ref<string[]>([]);
const displayPictureManagementModal = ref(false);
const maintenanceRequestLocked = ref(false);

const populatePictureList = () => {
  if (
    !props.maintenanceRequests.pictures ||
    props.maintenanceRequests.externalID < 1
  ) {
    pictureList.value = [];
    return;
  }

  pictureList.value = Array.from(
    { length: props.maintenanceRequests.pictures },
    (_, i) =>
      `http://webservices.acquaintcrm.co.uk/maintenancerequestimages/${props.maintenanceRequests.externalID}-${i + 1}.jpg`,
  );
};

onMounted(() => {
  populatePictureList();
});

watch(
  () => props.maintenanceRequests,
  () => {
    populatePictureList();
  },
);

/** Locks or unlocks the workorder record */
const updateMaintenanceRequestLock = async (locked: boolean) => {
  try {
    await apiClient.httpPostVoid(
      `database/MaintenanceRequest/${props.maintenanceRequests.id}/lock`,
      {
        lock: locked,
        extraInfo: "",
      },
    );
    maintenanceRequestLocked.value = true;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    maintenanceRequestLocked.value = false;
  }
};

watch(
  () => displayPictureManagementModal.value,
  () => {
    if (!displayPictureManagementModal.value) {
      updateMaintenanceRequestLock(false);
      return;
    }
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      (props.maintenanceRequests)
        ? (_openBlock(), _createBlock(_unref(DxGallery), {
            key: 0,
            id: "maintenanceRequests",
            "data-source": pictureList.value,
            loop: true,
            "show-nav-buttons": __props.maintenanceRequests.pictures > 1,
            "show-indicator": __props.maintenanceRequests.pictures > 1,
            "item-template": "item"
          }, {
            item: _withCtx(({ data }) => [
              _createVNode(CarouselPicture, {
                "record-id": __props.maintenanceRequests.externalID,
                "record-type": _unref(CarouselPictureType).MaintenanceRequest,
                pictureNumber: __props.maintenanceRequests.pictures,
                imageUrl: data,
                objectFit: 'scale-down'
              }, null, 8, ["record-id", "record-type", "pictureNumber", "imageUrl"])
            ]),
            _: 1
          }, 8, ["data-source", "show-nav-buttons", "show-indicator"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
    ])
  ]))
}
}

})